<main class="main mt-3">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>Sms:</div>
        <div class="remove-block-button">
          <a class="btn btn-sm" (click)="removeBlock()"
            ><i class="bi bi-trash-fill remove-block-icon"></i
          ></a>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-block-text
            [type]="'content'"
            (handleOnChange)="onChange($event, 'Sms')"
            [blockData]="block.variables?.Sms ?? ''"
            [placeholder]="smsPlaceholder"
            [maxLength]="105"
            variable="Sms"
          ></app-block-text>
        </div>
        <div class="col-12">
          <app-block-text
            [type]="'content'"
            (handleOnChange)="onChange($event, 'SmsCtaLink')"
            [blockData]="block.variables?.SmsCtaLink ?? ''"
            [placeholder]="smsCtaLinkPlaceholder"
            [maxLength]="4000"
            variable="SmsCtaLink"
            [canBeEmpty]="true"
          ></app-block-text>
        </div>
      </div>
    </div>
    <div
      class="right-side-container"
      [id]="block.blockId"
      (click)="onContainerClick($event)"
    >
      <app-pin [block]="block"></app-pin>
      <div class="right-side sms-text">
        <div class="row text-center">
          <div class="col-12" [innerHTML]="$safeNavigationMigration(block.variables?.Sms)"></div>
          <div class="col-12" *ngIf="block.variables?.SmsCtaLink">
            <a
              target="_blank"
              [innerHTML]="$safeNavigationMigration(block.variables?.SmsCtaLink)"
              [href]="$safeNavigationMigration(block.variables?.SmsCtaLink)"
            ></a>
          </div>
        </div>
      </div>
    </div>
    <div class="comments-side" *ngIf="!isPreview">
      <app-notification
        [notifications]="block.notifications"
        [blockId]="block.blockId"
      ></app-notification>
    </div>
  </div>
</main>
